import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { EnvironmentStore } from '../stores/environmentStore';

export const useEnvironmentStore = () =>
  useContext<{
    environmentStore: EnvironmentStore;
  }>(StoreContext);
